export const SETTINGS_ACTION_TYPE = 0;

export const CONTINUE_ACTION_TYPE = 1;

export const REAPPLY_ACTION_TYPE = 2;
